
import { NavPanelContainer } from "./NavPanel.styles";

const NavPanel = () => {
    return (
        <NavPanelContainer />
    );
}

export default NavPanel;
